module.exports = __webpack_public_path__ + "img/golf_cos1.dda0dc70.png";